import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import Location from './pages/Location';
import Clients from './pages/Clients';
import Phase from './pages/Phase';
import Tasks from './pages/Tasks';
import Processes from './pages/Processes';
import EmployeeEngagement from './pages/EmployeeEngagement';
import ResourceMapping from './pages/ResourceMapping';
import AddProject from './pages/Project';
import ProjectList from './pages/ProjectList';
import AddLevel from './pages/AddLevel';
import LevelList from './pages/LevelList';
import AddDepartment from './pages/AddDepartment';
import DepartmentList from './pages/DepartmentList';
import AddUser from './pages/AddUser';
import UserList from './pages/UserList';
import ApplicationSettings from './pages/ApplicationSettings';
import EmailConfiguration from './pages/EmailConfiguration';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
    background: {
      default: '#f5f5f5',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <div style={{ display: 'flex' }}>
          <Sidebar />
          <div style={{ flex: 1, marginLeft: 270, minHeight: '100vh' }}>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/location/*" element={<Location />} />
              <Route path="/clients/*" element={<Clients />} />
              <Route path="/phase/*" element={<Phase />} />
              <Route path="/tasks/*" element={<Tasks />} />
              <Route path="/project/add" element={<AddProject />} />
              <Route path="/processes/*" element={<Processes />} />
              <Route path="/employee-engagement/*" element={<EmployeeEngagement />} />
              <Route path="/resource-mapping/*" element={<ResourceMapping />} />
              <Route path="/project/list" element={<ProjectList />} />
              <Route path="/levels/add" element={<AddLevel />} />
              <Route path="/levels/list" element={<LevelList />} />
              <Route path="/departments/add" element={<AddDepartment />} />
              <Route path="/departments/list" element={<DepartmentList />} />
              <Route path="/users/add" element={<AddUser />} />
              <Route path="/users/list" element={<UserList />} />
              <Route path="/settings" element={<ApplicationSettings />} />
              <Route path="/email-configuration" element={<EmailConfiguration />} />
            </Routes>
          </div>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;